<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Campos</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Empresas Contratantes</small></h1>
<!-- end page-header -->

<div class="scrollable">
    <panel [noButton]="true">
        @if(!editNew){
        <div class="d-flex justify-content-between align-items-center">
            <h5>Listado de Empresas Contratantes</h5>
            <!-- @if(permissions?.search.create){ -->
            <button class="btn btn-success btn-xs" (click)="editNew=true"> <i class="fas fa-plus"></i> Nuevo</button>
            <!-- } -->
        </div>
        <div class="panel-body">

            <div class="row modal-body table-container">
                <div class="table-responsive">
                <table class="table table-sm table-hover">
                    <thead>
                        <th class="text-center">N°</th>
                        <th>Nombre</th>
                        <th class="text-center">Rut</th>
                        <th class="text-center">DV</th>
                        @if(permissions?.search.edit){
                        <th class="text-center"><i class="fas fa-cogs"></i></th>
                        }
                    </thead>

                    <tbody>
                        @if(listEntities?.length > 0){
                        @for(office of listEntities; track office; let i = $index){
                        <tr>
                            <td class="text-nowrap text-center">{{i + 1}}</td>
                            <td class="text-nowrap">{{office.name}}</td>
                            <td class="text-nowrap text-center">{{office.rut | numberPipe}}</td>
                            <td class="text-nowrap text-center">{{office.dv | uppercase}}</td>
                            <td class="text-nowrap text-center">
                                <!-- @if(permissions?.search.edit){ -->
                                <button class="btn btn-warning btn-xs btn-rounded"
                                    (click)="editOffice = office; editNew = true"><i class="fas fa-edit"></i></button>
                                <!-- } -->
                            </td>
                        </tr>
                        }
                        }
                        @else{
                        <tr>
                            <td colspan="5">No hay registros para mostrar.</td>
                        </tr>
                        }
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        }@else {
        <app-edit-office [office]="editOffice" (refresh)="refreshData($event)" [permissions]="permissions"></app-edit-office>
        }

    </panel>
</div>